/* Native Shopify language routing and authored theme UI labels. */
(() => {
  if (window.rs2LocalizationLoaded) return;
  window.rs2LocalizationLoaded = true;
  const ownedUI = '.rs2-content, .related-products, .rs2-menu, .header, .rs-header, product-info, cart-drawer, cart-items, .cart__footer, .st_reviews_widget, .collection, .collection-hero, .facets-container, .facets-wrapper, .facet-filters, .product-count, .product-count-vertical, .mobile-facets, #MainContent:has([data-rs2-about])';
  const protectedUI = 'script, style, noscript, code, pre, textarea, [contenteditable="true"], [data-rs2-no-translate], .shopify-policy__body, .st_rvws-review-row, .st_rvws-masonry-card, .st_rvws-review-content, .st_rvws-review-title, .st_rvws-masonry-title, .st_rvws-reviewer-name, [data-rs-highscores] tbody, .rs2-character-content .rte';
  const translatedAttributes = ['aria-label', 'title', 'alt', 'placeholder', 'data-play', 'data-pause', 'data-label-play', 'data-label-pause', 'data-dark-label', 'data-light-label', 'data-hero-heading', 'data-hero-action'];
  const productTitles = '.rs2-wear-slide__info h2, .product__title, .cart-item__name, .od-row h3, .card__heading, #product-grid h3, .upsell-product-title, .facet-checkbox__text-label, .active-facets__button-inner';
  const facets = '.facets-container, .facets-wrapper, .facet-filters, .mobile-facets, .product-count, .product-count-vertical, #ProductCountDesktop, #ProductCount';
  const productMedia = '.rs2-wear-slide, .product-card, .card-wrapper, media-gallery, .cart-item, .upsell-item';
  const maps = { en: new Map(), de: new Map() };
  // New hero copy also fills gaps while the existing proxy route is being retired.
  const heroPairs = [
    ["Für alle, die mit Pixeln groß geworden sind.", "For everyone who grew up with pixels."],
    ["Deine Cap.", "Your cap."],
    ["Dein Shirt.", "Your tee."],
    ["Dein Oversized.", "Your oversized."],
    ["Dein Pullover.", "Your sweatshirt."],
    ["Dein Hoodie.", "Your hoodie."],
    ["Deine Socken.", "Your socks."],
    ["Caps entdecken", "Discover caps"],
    ["Shirts entdecken", "Discover tees"],
    ["Oversized entdecken", "Discover oversized"],
    ["Pullover entdecken", "Discover sweatshirts"],
    ["Hoodies entdecken", "Discover hoodies"],
    ["Socken entdecken", "Discover socks"],
    ["Produkte durch Wischen entdecken", "Swipe to discover products"],
    ["Vorheriges Produkt", "Previous product"],
    ["Nächstes Produkt", "Next product"],
    ['Dein Style.', 'Your style.'],
    ['Eigene Charaktere. Echte Stickerei. In Bayern veredelt.', 'Original characters. Real embroidery. Finished in Bavaria.'],
    ['Alle Produkte', 'All clothing'],
    ['Pixel zum Tragen', 'Pixels to wear'],
    ['Produkt wählen', 'Choose a product'],
    ['Cap ansehen', 'View cap'], ['Shirt ansehen', 'View tee'],
    ['Oversized ansehen', 'View oversized tee'], ['Pullover ansehen', 'View sweatshirt'],
    ['Hoodie ansehen', 'View hoodie'], ['Socken ansehen', 'View socks'],
    ['Mehr Lieblingsstücke.', 'More pixel favourites.']
  ];
  const widgetPairs = [
    ['Kundenbewertungen', 'Customer reviews'],
    ['Pixel im echten Leben.', 'Pixels in real life.'],
    ['Deine Cap. Dein Pixel.', 'Your cap. Your pixel.'],
    ['Direkt aus der Stickmaschine', 'From the embroidery machine'],
    ['Mehr Platz für deinen Style', 'Room for your style'],
    ['Pixel bis in die Socken', 'Pixels down to your socks'],
    ['Das könnte dir gefallen.', 'You might also like.']
  ];
  for (const [de, en] of [...(window.rs2UITranslations?.pairs || []), ...heroPairs, ...widgetPairs]) {
    if (!maps.en.has(de)) maps.en.set(de, en);
    if (!maps.de.has(en)) maps.de.set(en, de);
  }
  const productPhrases = window.rs2UITranslations?.productPhrases || [];
  const productPatterns = Object.fromEntries(['en', 'de'].map(language => [language, productPhrases.map(pair => {
    const [from, to] = language === 'en' ? pair : [pair[1], pair[0]];
    const escaped = from.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    return [new RegExp(`(^|[^\\p{L}\\p{N}])${escaped}(?=$|[^\\p{L}\\p{N}])`, 'gu'), to];
  })]));
  const attributeSelector = translatedAttributes.map(attribute => `[${attribute}]`).join(',');
  const eligible = (element) => element?.closest('.rs2') && element.closest(ownedUI) && !element.closest(protectedUI);
  function translateText(value, language, isProductTitle = false, isFacet = false) {
    if (!value) return value;
    if (isFacet) {
      const results = value.trim().match(/^(\d+) (?:von|of) (\d+) (?:Produkten|products)$/);
      if (results) return value.replace(value.trim(), language === 'en'
        ? `${results[1]} of ${results[2]} products` : `${results[1]} von ${results[2]} Produkten`);
      const counted = value.trim().match(/^((.*?) \()?(\d+) (ausgewählt|selected|Produkte?|products?)(\))?$/);
      if (counted && Boolean(counted[1]) === Boolean(counted[5])) {
        const count = counted[3];
        const selected = ['ausgewählt', 'selected'].includes(counted[4]);
        const unit = selected ? (language === 'en' ? 'selected' : 'ausgewählt')
          : language === 'en' ? (count === '1' ? 'product' : 'products') : (count === '1' ? 'Produkt' : 'Produkte');
        const label = counted[1] ? translateText(counted[2], language, true) + ' (' : '';
        return value.replace(value.trim(), label + count + ' ' + unit + (counted[5] || ''));
      }
    }
    if (isProductTitle) {
      let result = value;
      for (const [boundary, to] of productPatterns[language]) {
        result = result.replace(boundary, (_, prefix) => prefix + to);
      }
      return translateText(result, language);
    }
    const whitespace = value.match(/^(\s*)([\s\S]*?)(\s*)$/);
    const core = whitespace[2].replace(/\s+/g, ' ');
    let replacement = maps[language].get(core);
    if (!replacement) {
      // Numbered headings and arrow links keep their punctuation and markup.
      const decorated = core.match(/^([\d /·←→↗]*)(.*?)([ :←→↗]*)$/);
      const translated = maps[language].get(decorated[2]);
      if (translated) replacement = decorated[1] + translated + decorated[3];
    }
    if (!replacement) {
      for (const pair of [[' — Zweites Produktbild', ' — Second product image'], [', im echten Leben.', ', off screen.']]) {
        const [from, to] = language === 'en' ? pair : [pair[1], pair[0]];
        if (core.endsWith(from)) replacement = core.slice(0, -from.length) + to;
      }
    }
    return replacement ? whitespace[1] + replacement + whitespace[3] : value;
  }
  function translateNode(node, language) {
    if (!node.nodeValue?.trim() || !eligible(node.parentElement)) return;
    const parent = node.parentElement;
    const next = parent.closest('.active-facets__button-inner')
      ? node.nodeValue.split(':').map(part => translateText(part, language, true)).join(':')
      : translateText(node.nodeValue, language, Boolean(parent.closest(productTitles)), Boolean(parent.closest(facets)));
    if (next !== node.nodeValue) node.nodeValue = next;
  }
  function translateAttributes(element, language, attributes = translatedAttributes) {
    if (!eligible(element)) return;
    let isProduct;
    let isFacet;
    for (const attribute of attributes) {
      const value = element.getAttribute(attribute);
      if (!value) continue;
      if (isFacet === undefined) isFacet = Boolean(element.closest(facets));
      const productAttribute = ['alt', 'title', 'aria-label'].includes(attribute);
      if (productAttribute && isProduct === undefined) isProduct = Boolean(element.closest(productMedia) || element.closest(productTitles));
      const next = translateText(value, language, productAttribute && isProduct, isFacet);
      if (next !== value) element.setAttribute(attribute, next);
    }
  }
  function translateUI(root = document) {
    if (!document.createTreeWalker || !window.rs2UITranslations) return;
    const language = /^\/en(?:\/|$)/.test(window.location.pathname) ? 'en' : 'de';
    if (document.querySelector('[data-rs2-about]')) {
      const title = translateText(document.title, language);
      if (title !== document.title) document.title = title;
      const description = document.querySelector('meta[name="description"]');
      if (description) {
        const content = translateText(description.content, language);
        if (content !== description.content) description.content = content;
      }
    }
    const walker = document.createTreeWalker(root, 4);
    let node;
    while ((node = walker.nextNode())) translateNode(node, language);
    if (root.nodeType === 1 && root.matches(attributeSelector)) translateAttributes(root, language);
    for (const element of root.querySelectorAll(attributeSelector)) translateAttributes(element, language);
  }
  let uiObserver;
  function watchUI() {
    translateUI();
    if (uiObserver || !document.createTreeWalker) return;
    uiObserver = new MutationObserver((mutations) => {
      const language = /^\/en(?:\/|$)/.test(window.location.pathname) ? 'en' : 'de';
      const roots = new Set();
      for (const mutation of mutations) {
        if (mutation.type === 'childList') {
          for (const node of mutation.addedNodes) {
            if (node.nodeType === 1) roots.add(node);
            else if (node.nodeType === 3 && node.isConnected) translateNode(node, language);
          }
        } else if (mutation.target.isConnected) {
          if (mutation.type === 'attributes') translateAttributes(mutation.target, language, [mutation.attributeName]);
          else translateNode(mutation.target, language);
        }
      }
      // Added parent subtrees already include their children; scan each branch once.
      for (const root of roots) {
        let ancestor = root.parentElement;
        while (ancestor && !roots.has(ancestor)) ancestor = ancestor.parentElement;
        if (root.isConnected && !ancestor) translateUI(root);
      }
    });
    // Exact-match writes are idempotent; unknown app/customer content is untouched.
    uiObserver.observe(document.documentElement, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: translatedAttributes });
  }
  function update() {
    const current = new URL(window.location.href);
    const active = /^\/en(?:\/|$)/.test(current.pathname) ? 'en' : 'de';
    const original = current.pathname.replace(/^\/en(?=\/|$)/, '') || '/';
    document.querySelectorAll('[data-rs2-language-switcher]').forEach(switcher => {
      switcher.setAttribute('aria-label', active === 'en' ? 'Language' : 'Sprache');
      const native = switcher.querySelector('[data-rs2-native-language]');
      const links = switcher.querySelector('[data-rs2-language-links]');
      if (native) {
        native.hidden = false;
        const returnTo = native.querySelector('[name="return_to"]');
        if (returnTo) returnTo.value = current.pathname + current.search + current.hash;
      }
      if (links) links.hidden = Boolean(native);
      switcher.querySelectorAll('[data-rs2-language]').forEach(link => {
        const language = link.dataset.rs2Language;
        if (language !== 'de' && language !== 'en') return;
        const path = language === 'de' ? original : `/en${original === '/' ? '' : original}`;
        const target = new URL(current.origin + path);
        target.search = current.search;
        target.hash = current.hash;
        link.setAttribute('href', target.href);
        if (language === active) link.setAttribute('aria-current', 'page');
        else link.removeAttribute('aria-current');
      });
    });
  }
  // Product variants update the URL with replaceState; refresh just before routing.
  document.addEventListener('submit', event => {
    if (event.target.closest('[data-rs2-native-language]')) update();
  }, true);
  document.addEventListener('click', event => {
    if (event.target.closest('[data-rs2-language-switcher]')) update();
  }, true);
  function initialize() { watchUI(); update(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
  window.addEventListener('popstate', () => { update(); translateUI(); });
})();
